import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
const Modal = ({ children, onClose }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);
    const handleContainerClick = (e) => {
        e.stopPropagation();
    };
    return (_jsx("div", { className: "fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-gray-900/50 p-4 sm:items-center sm:p-6", children: _jsx("div", { className: "relative mx-auto w-full max-w-xl sm:max-w-2xl lg:max-w-3xl", onClick: handleContainerClick, children: children }) }));
};
export default Modal;
